









































































































































































































import { $eventsBus } from "@/main";
import BaseChart from "@/app/shared/components/base/BaseChart.js";
import BaseVideoRangeSlider from "@/app/shared/components/base/BaseVideoRangeSlider.vue";
import utils from "@/app/shared/utils/utils.js";

export default {
  name: "PartsCreatorTimeline",
  components: { BaseChart, BaseVideoRangeSlider },
  mixins: [utils],
  props: {
    zoom: {
      type: Number,
      default: 100,
    },
  },
  data: function () {
    return {
      isTimelineScrollbarVisible: false,
      chartData: null,
      isShowChart: false,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              display: false,
              gridLines: {
                display: false,
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              display: false,
              gridLines: {
                display: false,
                drawOnChartArea: false,
              },
            },
          ],
        },
        tooltips: {
          enabled: false,
        },
        elements: {
          point: {
            radius: 0,
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
      },
      //PlayheadDrag parameters
      lastPlayheadDragResponseTime: 0,
      collectedMovementX: 0,
      currentMovmentXToShow: 0,
      isTryingToSeekNow: false,
      isPlayheadDragging: false,
    };
  },
  computed: {
    items() {
      return this.$store.state.items;
    },
    itemsToShow: function () {
      return this.$store.state.items.filter((i) => !i.hidden);
    },
    contentDuration: function () {
      let duration = 0;
      this.$store.state.items
        .filter((i) => !i.hidden)
        .forEach((item) => {
          duration += item.duration;
        });
      return duration;
    },
    allPartsToShow: function () {
      return this.$store.state.items
        .filter((i) => !i.hidden)
        .reduce((acc, val) => acc.concat(val.parts), []);
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    selectedPart: {
      get: function () {
        return this.$store.state.selectedPart;
      },
      set: function (part) {
        this.$store.commit("changeSelectedPart", part);
      },
    },
    contentVideoCurrentTime: {
      get: function () {
        return this.$store.state.contentVideoCurrentTime;
      },
      set: function (value) {
        this.$store.commit("contentVideoCurrentTime", value);
      },
    },
  },
  watch: {
    previewItem: function () {
      this.tryUpdateGraphData(this.previewItem);
    },
  },
  created() {
    $eventsBus.$on("contentTimeUpdated", () => {
      this.currentMovmentXToShow = 0;
      this.isTryingToSeekNow = false;
    });
  },
  mounted() {
    if (this.$refs.creatorTimeline) {
      this.isTimelineScrollbarVisible =
        this.$refs.creatorTimeline.scrollHeight >
        this.$refs.creatorTimeline.parentElement.clientHeight;
    }
    this.tryUpdateGraphData(this.previewItem);
  },
  updated() {
    if (this.$refs.creatorTimeline) {
      this.isTimelineScrollbarVisible =
        this.$refs.creatorTimeline.scrollHeight >
        this.$refs.creatorTimeline.parentElement.clientHeight;
    }
  },
  methods: {
    tryUpdateGraphData(item) {
      if (!item || !item.autocutParameters.isReadyToAutocut) {
        setTimeout(() => {
          this.tryUpdateGraphData(this.previewItem);
        }, 1000);
        return;
      }
      if (item.bitrateGraph) {
        this.updateGraphData(item);
      } else {
        this.axios
          .post(
            "/v2.0/autocut/getFramesInfo",
            {
              fileId: item.fileId,
              params: {
                partCount: item.autocutParameters.partsCount,
                duration: item.autocutParameters.partsDurations,
              },
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            item.bitrateGraph = response.data.bitrateGraph;
            this.updateGraphData(item);
          })
          .catch((erorr) => {
            console.error(erorr);
          });
      }
    },
    updateGraphData(item) {
      let data = [];
      item.bitrateGraph.forEach((point) => {
        data.push(point.pkt_size);
      });
      this.chartData = {
        labels: data,
        datasets: [
          {
            backgroundColor: "#f87979",
            data: data,
          },
        ],
      };
    },
    clickOnRow(part) {
      if (this.selectedPart === part) {
        this.selectedPart = null;
      } else {
        this.selectedPart = part;
        let item = this.itemsToShow.find(
          (i) => i.id === this.selectedPart.parentItemInfo.id
        );
        this.selectItem(item);
        setTimeout(() => {
          $eventsBus.$emit(
            "setContentCurrentVideoTime",
            this.selectedPart.startTime
          );
        }, 5);
      }
    },
    seekTime(event) {
      let allTime = this.contentDuration;
      let currentTargetRect = event.currentTarget.getBoundingClientRect();
      let eventOffsetX = event.pageX - currentTargetRect.left;
      let newTime = (eventOffsetX / currentTargetRect.width) * allTime;
      $eventsBus.$emit(
        "setContentTime",
        newTime < 0 ? 0 : newTime > allTime ? allTime : newTime
      );
    },
    startDrag(side) {
      /*       this.changingDuration = true;
       */
      let item = this.itemsToShow.find(
        (i) => i.id === this.selectedPart.parentItemInfo.id
      );
      this.selectItem(item);
      $eventsBus.$emit("isPlayingForceDisable", true);
      $eventsBus.$emit(
        "setContentCurrentVideoTime",
        side === "left"
          ? this.selectedPart.startTime
          : this.selectedPart.finishTime
      );
    },
    changeDuration(time) {
      //this.previewItem.currentVariation.checkAndUpdateMusicTime();
      $eventsBus.$emit("setContentCurrentVideoTime", time);
    },
    stopDrag(startTime) {
      $eventsBus.$emit("setContentCurrentVideoTime", startTime);
      $eventsBus.$emit("isPlayingForceDisable", false);
      //this.changingDuration = false;
    },
    startDragPlayhead(event) {
      $eventsBus.$emit("isPlayingForceDisable", true);
      window.onmousemove = this.movePlayhead.bind(event);
      window.onmouseup = this.stopDragPlayhead.bind(event);
      this.lastPlayheadDragResponseTime = Date.now();
      this.isPlayheadDragging = true;
    },
    movePlayhead(event) {
      event.preventDefault();
      this.collectedMovementX += event.movementX;

      this.lastPlayheadDragResponseTime = Date.now();
      this.changeTime(Date.now());
    },
    changeTime(responseTime) {
      if (this.collectedMovementX === 0 || this.isTryingToSeekNow) {
        return;
      }
      this.currentMovmentXToShow = this.collectedMovementX;
      if (responseTime - this.lastPlayheadDragResponseTime < 200) {
        setTimeout(() => {
          this.changeTime(responseTime + 200);
        }, 200);
        return;
      }
      let newTime = 0;
      newTime =
        this.contentVideoCurrentTime +
        (this.collectedMovementX /
          this.$refs.creatorTimelinePlayheadContainer.offsetWidth) *
          this.contentDuration;
      newTime = Math.floor(newTime * 100) / 100;
      newTime =
        newTime < 0
          ? 0
          : newTime > this.contentDuration
          ? this.contentDuration
          : newTime;
      if (newTime !== this.contentVideoCurrentTime) {
        $eventsBus.$emit("setContentTime", newTime);
        this.collectedMovementX = 0;
        this.isTryingToSeekNow = true;
      } else {
        this.collectedMovementX = 0;
        this.currentMovmentXToShow = 0;
        this.isTryingToSeekNow = false;
      }
    },
    stopDragPlayhead(event) {
      window.onmouseup = null;
      window.onmousemove = null;
      $eventsBus.$emit("isPlayingForceDisable", false);
      this.isPlayheadDragging = false;
    },
    selectItem(item) {
      this.$store.commit("changeSelectItem", item);
    },
    getDurationOfPreviousItemsToShowByPart(part) {
      let item = this.itemsToShow.find((i) => i.id === part.parentItemInfo.id);
      return this.getDurationOfPreviousItemsToShow(item);
    },
    getDurationOfPreviousItemsToShow(item) {
      let itemIndex = this.itemsToShow.indexOf(item);
      if (itemIndex === -1) {
        return 0;
      }
      let allDuration = 0;
      for (let index = 0; index < itemIndex; index++) {
        allDuration += this.itemsToShow[index].duration;
      }
      return allDuration;
    },
    getItemThumbs(item) {
      let thumbs =
        item.thumbs.length === 0
          ? item.loadingParameters.localThumbs
          : item.thumbs;

      return thumbs.map(
        (thumb) => (item.thumbs.length === 0 ? "" : this.$baseURL) + thumb
      );
    },
  },
};
